import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/__generated__/EntryPointContentQuery$parameters';

export const asyncBulkOpsCoreFullEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-bulkOps-core-full" */ './src/EntryPointContent.tsx'),
	),
	getPreloadProps: ({ cloudId }: { cloudId: string }) => ({
		queries: {
			permissionsQuery: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
